import styled from 'styled-components';
import { getKeyframes } from '../utils/getKeyframes';
import {
  shellDivider,
  headerMobileSize,
  headerSize,
  media,
  miniNavbarSize,
  navbarMinSize,
  navbarSize,
} from '../utils/variables';

export const HeaderLayout = styled.header<{
  isNavOpen: boolean;
}>`
  background-color: var(--header-background);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-bottom: 1px solid ${shellDivider};
  height: ${headerSize}px;
  position: fixed;
  top: var(--billing-banner-height, 0px);
  right: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  animation: fadeIn 500ms forwards;
  transition: 250ms;
  z-index: 2;
  ${({ isNavOpen }) =>
    isNavOpen
      ? `
            width: calc(100vw - ${navbarSize});
            max-width: calc(100vw - ${navbarMinSize});
        `
      : `
            width: calc(100vw - ${miniNavbarSize});
            max-width: calc(100vw - ${miniNavbarSize});
        `}

  ${media.mobile} {
    width: 100vw;
    max-width: 100vw;
    height: ${headerMobileSize}px;
  }

  ${media.tablet} {
    width: 100vw;
    max-width: 100vw;
    height: ${headerMobileSize}px;
  }

  ${getKeyframes('fadeIn')}
`;
